import script from "./dataCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./dataCenter.vue?vue&type=script&setup=true&lang=js"

import "./dataCenter.vue?vue&type=style&index=0&id=c4833388&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4833388"]])

export default __exports__